import { render, staticRenderFns } from "./FilePondUploadWidget.vue?vue&type=template&id=2a0369a6&scoped=true"
import script from "./FilePondUploadWidget.vue?vue&type=script&lang=js"
export * from "./FilePondUploadWidget.vue?vue&type=script&lang=js"
import style0 from "./FilePondUploadWidget.vue?vue&type=style&index=0&id=2a0369a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.103.0__lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0369a6",
  null
  
)

export default component.exports